import React, { Component } from 'react';
import Layout from './components/Layout/Layout.js'
import Home from './components/Home/Home.js'
import Documentation from './components/Documentation/Documentation.js'
import Collaborate from './components/Collaborate/Collaborate.js'
import Navigation from './components/Navigation/Navigation.js'
import PSITRESBuilder from './container/PSITRESBuilder/PSITRESBuilder.js'
import { BrowserRouter } from 'react-router-dom'
import { Route, Link } from "react-router-dom";




function App(){


    return (
      <BrowserRouter basename = '/'>
        <div>
          <Navigation/>
          <Route exact path='/geo/ice/Home' component = {Home} />
          <Route exact path='/geo/ice/OATRC' component = {PSITRESBuilder}/>
          <Route exact path='/geo/ice/SKQ2015' component = {PSITRESBuilder}/>
          <Route exact path='/geo/ice/documentation' component = {Documentation} ship_name = "Documentation"/>
          <Route exact path='/geo/ice/collaborate' component = {Collaborate} ship_name = "Collaborate"/>

        </div>
      </BrowserRouter>
    );


}
export default App;



// WEBPACK FOOTER //
// ./src/App.js